import { Link } from "react-router";

export function Logo({ size = "text-2xl" }) {
  return (
    <Link to="/" className="flex items-center gap-3">
      <img src="/favicon.svg" alt="RoleLogic Logo" className="w-10 h-10" />
      <div className={`font-sans font-semibold text-white ${size}`}>
        RoleLogic
      </div>
    </Link>
  );
}
